import { initBottomCvArea, initSharedPageInteractions, initSmoothAnchorLinks, syncChangedActionForm } from './shared_page_interactions'

export {
  initBottomCvArea,
  initSmoothAnchorLinks,
  syncChangedActionForm,
}

export function initInterviewArchive() {
  initSharedPageInteractions({ smoothAnchorLinks: 'all' })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInterviewArchive)
} else {
  initInterviewArchive()
}
